import {
    apiGetMemberNotificationSummary,
    apiGetMemberNotificationUnreadCount,
} from '@/api/API';

export default {
    namespaced: true,
    state: {
        unreadCount: 0,
        unpaidOrderCount: 0,
        singleUnpaidOrderId: null,
        latestUnread: [],
    },
    mutations: {
        setUnreadCount(state, value) {
            state.unreadCount = Number(value) || 0;
        },
        setSummary(state, value) {
            state.unreadCount = Number(value?.UnreadCount) || 0;
            state.unpaidOrderCount = Number(value?.UnpaidOrderCount) || 0;
            state.singleUnpaidOrderId = value?.SingleUnpaidOrderId || null;
            state.latestUnread = Array.isArray(value?.LatestUnread) ? value.LatestUnread : [];
        },
    },
    actions: {
        async fetchUnreadCount({ commit }) {
            try {
                const response = await apiGetMemberNotificationUnreadCount();
                commit('setUnreadCount', response?.data?.Count);
            } catch { /* 暫時性錯誤時保留最後一次成功取得的未讀數。 */ }
        },
        async fetchSummary({ commit }) {
            const response = await apiGetMemberNotificationSummary();
            commit('setSummary', response.data || {});
            return response.data || {};
        },
    },
};
